<template>
  <div class="create-edit-payment-link">
    <div class="page-title application-detail-header">
      <i class="el-icon-arrow-left icon-back" @click="goBack" />
      {{ title }}
    </div>

    <div v-if="type==='detail' && paymentLinkInfo.status" class="title">
      <span>{{ paymentLinkInfo.title }}</span> <el-tag class="tag-custom" :type="activeStatusMap(paymentLinkInfo.status).type">{{ activeStatusMap(paymentLinkInfo.status).label }}</el-tag>
    </div>
    <div v-if="type==='detail'" class="link">
      <span class="link-url">{{ paymentLinkInfo.link_url }}</span>
      <el-button icon="el-icon-copy-document" class="btn-copy" size="mini" type="primary" :data-clipboard-text="paymentLinkInfo.link_url " @click="onClickCopyBtn('.btn-copy','Link')">
        {{ $t('payment_links.copy_link') }}
      </el-button>
      <el-popover
        placement="bottom"
        trigger="hover"
      >
        <img :src="link_qr_base64" alt="" width="300px">
        <el-button slot="reference" size="mini" style="margin-left: 12px;">{{ $t('payment_links.show_qr_code') }}</el-button>
      </el-popover>
    </div>

    <PaymentLink v-if="type!=='detail'" />
    <template v-else>
      <el-tabs v-model="activeName" type="card">
        <template v-for="(item,index) in componentConfig">
          <el-tab-pane :key="index" :label="item.label" :name="item.compName" />
        </template>
      </el-tabs>
      <keep-alive>
        <component :is="activeName" :key="activeName" @getInfo="getInfo" />
      </keep-alive>
    </template>

  </div>
</template>

<script>
import { activeStatusMap } from '@/utils/maps'
import Clipboard from 'clipboard'

export default {
  name: 'Payment_Link_Detail',
  components: {
    PaymentLink: () => import('./components/tabs/paymentLink.vue'),
    TransactionsList: () => import('./components/tabs/transactionsList.vue')
  },
  data() {
    return {
      activeName: 'PaymentLink',
      form: {},
      paymentLinkInfo: {},
      link_qr_base64: ''
    }
  },
  computed: {
    title() {
      if (this.type === 'detail') {
        return this.$t('payment_links.payment_link_details')
      } else if (this.type === 'edit') {
        return this.$t('payment_links.edit_payment_link')
      } else {
        return this.$t('payment_links.create_payment_link')
      }
    },
    componentConfig() {
      return [
        { compName: 'PaymentLink', label: this.$t('payment_links.link_details') },
        { compName: 'TransactionsList', label: this.$t('payment_links.transactions') }
      ]
    },
    type() {
      return this.$route.query.type
    },
    activeStatusMap() {
      return val => activeStatusMap(val)
    }
  },
  methods: {
    getInfo(data) {
      this.form = data || {}
      this.link_qr_base64 = this.form.link_qr_base64 || ''
      this.paymentLinkInfo = this.form.payment_link || {}
    },
    onClickCopyBtn(selectClass, name) {
      const btnCopy = new Clipboard(selectClass)
      btnCopy.on('success', () => {
        this.$message.success(`Copy ${name} Successfully!`)
        btnCopy.destroy()
      })
      btnCopy.on('error', function(e) {
        btnCopy.destroy()
      })
    },
    goBack() {
      this.$router.push({ name: 'Sub_Merchant_Content', params: { sub_merchant_no: this.$route.params.sub_merchant_no }, query: { page: this.$route.query.page, limit: this.$route.query.limit, activeName: 'PaymentLink' }})
    }
  }
}
</script>

<style lang="scss">
  .create-edit-payment-link {
    .head-img-upload .el-upload--picture-card {
      width: 80px;
      height: 80px;
      line-height: 88px;
      border-radius: 50%;
    }
    .head-img-upload .el-upload-list--picture-card .el-upload-list__item {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .head-img-upload-btn .el-upload--picture-card {
      width: 80px;
      height: 80px;
      border: 0;
    }

    .vue-image-crop-upload .vicp-wrap .vicp-operate a{
        border: 1.5px solid #98A1B4;
        color: #616D85;
        border-radius: 4px;
    }
    .vue-image-crop-upload .vicp-wrap .vicp-operate a:nth-child(2){
        color: #FFFFFF;
        background: #1D3A71;
      }
    .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right{
      float: none;
      margin-top: 30px;
      margin-left:330px;
    }
    .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview{
      height: 200px;
    }
   .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item.vicp-preview-item-circle{
      width: 150px !important;
      height: 150px !important;
   }
    .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item.vicp-preview-item-circle img{
      width: 150px !important;
      height: 150px !important;
    }
  }
</style>

<style lang="scss" scoped>
.create-edit-payment-link{
  margin: 48px;
  background: #fff;
  border-radius: 4px;
  .application-detail-header {
    width: 100%;
    padding-bottom: 12px;
    font-size: 24px;
    border-bottom: 1px solid #D3D7DF;
    .icon-back{
      cursor: pointer;
    }
  }
  .title{
    height: 28px;
    line-height: 28px;
    color: #1D3A71;
    font-weight: 700;
    margin-bottom: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span:not(.tag-custom){
      display: inline-block;
      max-width: 420px;
      // margin-right: 12px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .tag-custom{
      border-radius: 30px;
      margin-left: 24px;
      padding: 0 35px;
      height: 30px;
      line-height: 30px;
      border: none;
      vertical-align: middle;
      &.el-tag--info{
        color: #B45309;
        background-color: #FDE68A;
      }
      &.el-tag--success{
        color: #047857;
        background-color: #A7F3D0;
      }
      &.el-tag--danger{
        color: #71110E;
        background-color: #FCA5A5;
      }
    }
  }
  .link{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 24px;
    .link-url{
      display: inline-block;
      width: 308px;
      font-size: 12px;
      padding: 8px;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.10);
      background: rgba(0, 0, 0, 0.02);
      margin-right: 12px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
</style>
